// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import React from 'react';

export default () => (
    <svg
        width='41'
        height='41'
        viewBox='0 0 41 41'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        xmlnsXlink='http://www.w3.org/1999/xlink'
    >
        <circle
            cx='20.3984'
            cy='20.002'
            r='20'
            fill='url(#pattern-zoom)'
        />
        <defs>
            <pattern
                id='pattern-zoom'
                patternContentUnits='objectBoundingBox'
                width='1'
                height='1'
            >
                <use
                    xlinkHref='#image0_615_81812'
                    transform='scale(0.0138889)'
                />
            </pattern>
            <image
                id='image0_615_81812'
                width='72'
                height='72'
                xlinkHref='data:image/png;base64,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'
            />
        </defs>
    </svg>
);
